export default __webpack_public_path__ + "static/media/LKC active.291b41ab.svg";